import axios from "axios";
import store from "@/store";
import { MessageBox, Message } from "element-ui";

const successCode = [200, 0, "200", "0"];
const CODE_MESSAGE = {
  401: "认证失败，无法访问系统资源",
  403: "当前操作没有权限",
  404: "访问资源不存在",
  default: "系统未知错误，请反馈给管理员",
};

// 请求超时
const http = axios.create({
  withCredentials: true,
  timeout: 10000,
});

// 处理请求返回值
const handleResponse = ({ data, status, statusText }) => {
  // data: { data, message, status }
  //处理code
  let code = data?.status || 0;
  successCode.includes(code) && (code = 0);
  const msg = CODE_MESSAGE[code] || data.message || CODE_MESSAGE["default"];

  if (code === 401) {
    MessageBox.confirm(
      "登录状态已过期，您可以继续留在该页面，或者重新登录",
      "系统提示",
      {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning",
      }
    ).then(() => {
      store.dispatch("logOut");
    });
  } else if (code === 500) {
    Message.error("系统网络错误，请刷新后重试！");
    return Promise.reject(new Error(msg));
  } else if (code !== 0) {
    Message.error(msg);
    return Promise.reject("error");
  } else {
    return Promise.resolve(data);
  }
};

// 请求拦截
http.interceptors.request.use(
  (config) => {
    const TOKEN = localStorage.getItem("rypc_token");
    if (TOKEN) {
      // 让每个请求携带自定义 token
      config.headers["Authorization"] = TOKEN;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => handleResponse(response),
  (error) => {
    console.log("error:" + error);
    let { message: msg } = error;
    if (msg == "Network Error") {
      msg = "后端接口连接异常";
    } else if (msg.includes("timeout")) {
      msg = "系统接口请求超时";
    } else if (msg.includes("Request failed with status code")) {
      msg = "系统接口" + msg.substr(msg.length - 3) + "异常";
    }
    Message.error(msg);
    return Promise.reject(error);
  }
);

export default http;
